/**
 * Türkçe sözlük · motor: motorun KOD olarak verdiği mesajların cümleleri
 * (kullanıcı kararı 27.10.2026). Parçalar motorun bölümlerine göre.
 */
import { deger } from "./motor/deger";
import { olcu } from "./motor/olcu";
import { sanal } from "./motor/sanal";

export const motor = { ...deger, ...olcu, ...sanal };
